module.exports = __webpack_public_path__ + "img/logox.62574975.png";